import { Controller } from '@hotwired/stimulus'
import { isNonNegativeNumeric, isNumericNotZero, isPresent } from 'util/validation'

// Connects to data-controller="form-enabler"
export default class extends Controller {
  static targets = ['requireable', 'disableable']

  static values = {
    isValid: {
      type: Boolean,
      default: false
    }
  }

  connect () {
    this.requireableTargets.forEach(target => {
      if (!target.hasAttribute('data-action')) {
        target.setAttribute('data-action', 'input->form-enabler#validate')
      }
    })

    this.validate()
  }

  isValidValueChanged () {
    if (this.isValidValue === true) {
      this.#enable()
    } else {
      this.#disable()
    }
  }

  validate () {
    let isNowValid = true

    this.requireableTargets.forEach(target => {
      if (!this.#isValidField(target)) {
        isNowValid = false
      }
    })

    this.isValidValue = isNowValid
  }

  #enable () {
    this.disableableTargets.forEach(target => {
      target.removeAttribute('disabled')
    })
  }

  #disable () {
    this.disableableTargets.forEach(target => {
      target.setAttribute('disabled', 'disabled')

      if (target.checked) {
        target.checked = false
        target.dispatchEvent(new Event('change'))
      }
    })
  }

  #isValidField (target) {
    const value = (target.value + '').trim()

    switch (target.dataset.validation) {
      case 'number_not_zero':
        return isNumericNotZero(value)
      case 'number_or_zero':
        return isNonNegativeNumeric(value)
      default:
        return isPresent(value)
    }
  }
}
